exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "delegated-card-list-mobile .delegated-card-list{margin-top:20px;margin-bottom:75px}delegated-card-list-mobile .delegated-card-list .flex-row{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin:0 0 9px}delegated-card-list-mobile .delegated-card-list .flex-row .flex-item{flex:1 0 49%;margin-top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/food-benefit.module/components/delegatedCardListMobile/delegatedCardListMobile.scss
// module id = 1700
// module chunks = 0